// windows.query.ts
import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { WindowsStore, WindowsState } from './tabs.store';
import { FinalProductWindows } from 'src/app/models/final_product_windows.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WindowsQuery extends QueryEntity<WindowsState> {
  constructor(protected override store: WindowsStore) {
    super(store);
  }

  getByFinalProductId(finalProductId: number): FinalProductWindows[] {
    return this.getAll({
      filterBy: entity => entity.final_product_id === finalProductId
    });
  }

  selectByFinalProductId(finalProductId: number): Observable<FinalProductWindows[]> {
    return this.selectAll({
      filterBy: entity => entity.final_product_id === finalProductId
    });
  }


}
